import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const BulkEdit = (props: SvgIconProps) => {
  return (
    <SvgIcon sx={{ width: '12px', height: '13px', color: '#000000' }} viewBox="0 0 12 13" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.37333 4.51333L7.98667 5.12667L1.94667 11.1667H1.33333V10.5533L7.37333 4.51333ZM9.77333 0.5C9.60667 0.5 9.43333 0.566667 9.30667 0.693333L8.08667 1.91333L10.5867 4.41333L11.8067 3.19333C12.0667 2.93333 12.0667 2.51333 11.8067 2.25333L10.2467 0.693333C10.1133 0.56 9.94667 0.5 9.77333 0.5ZM7.37333 2.62667L0 10V12.5H2.5L9.87333 5.12667L7.37333 2.62667Z"
        fill="#000000"
      />
    </SvgIcon>
  );
};

export default BulkEdit;
